// extracted by mini-css-extract-plugin
export default {"modalFooter":"EditSeriesModalContent-modalFooter-xJgSU ModalFooter-modalFooter-wjkx5","selected":"EditSeriesModalContent-selected-Nxk9n"};